import { unrefElement, useEventListener } from "@vueuse/core";
import { computedWithControl, isClient } from "@vueuse/shared";
import { computed } from "vue";
const defaultWindow = isClient ? window : undefined;
/**
 * Reactive `document.activeElement`
 *
 * @see https://vueuse.org/useActiveElement
 * @param options
 */
export function useActiveElement(options = {}) {
    const { window = defaultWindow } = options;
    const activeElement = computedWithControl(() => null, () => window === null || window === void 0 ? void 0 : window.document.activeElement);
    if (window) {
        useEventListener(window, "blur", () => {
            const scheduler = window.requestAnimationFrame || window.setTimeout;
            scheduler(() => activeElement.trigger());
        }, true);
        useEventListener(window, "focus", activeElement.trigger, true);
    }
    return activeElement;
}
/**
 * Track if focus is contained within the target element
 *
 * @see https://vueuse.org/useFocusWithin
 * @param target The target element to track
 * @param options Focus within options
 */
export function useFocusWithin(target, options = {}) {
    const activeElement = useActiveElement(options);
    const targetElement = computed(() => unrefElement(target));
    const focused = computed(() => targetElement.value && activeElement.value ? targetElement.value.contains(activeElement.value) : false);
    return { focused };
}
